import React from 'react'
import { useNavigate } from 'react-router-dom'

import { VerifyEmailForm } from './VerifyEmailForm'
import { ResetPasswordForm } from '../ResetPasswordForm'

import routePath from 'router/routePath'
import { useAPIForgotPassword } from 'api/apiHooks/useAPIForgotPassword'

export const ForgotPassword: React.FC = () => {
  const [phase, setPhase] = React.useState<'email' | 'code'>('email')
  const [gotEmail, setGotEmail] = React.useState('')
  const navigate = useNavigate()

  const { mutate: forgotPassword } = useAPIForgotPassword()

  const onCancel = () => {
    navigate(routePath.login)
  }

  if (phase === 'code') {
    return (
      <ResetPasswordForm
        onCompletedClick={() => {
          navigate(routePath.login)
        }}
        mode="forgot"
        email={gotEmail}
        onCancel={onCancel}
      />
    )
  }
  return (
    <VerifyEmailForm
      onCancel={onCancel}
      onSuccess={(email) => {
        forgotPassword({ email })
        setGotEmail(email)
        setPhase('code')
      }}
    />
  )
}
